import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LsCardComponent } from '@axess/ng-limestone';
import { BaseRoute } from '@core/data-access/models/routes.model';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizedDatePipe } from '@shared/pipes/localized-date/localized-date.pipe';
import { ExhibitionModel } from '@store/exhibition/exhibition.interface';

@Component({
  selector: 'app-exhibition-card',
  templateUrl: './exhibition-card.component.html',
  standalone: true,
  imports: [RouterLink, LocalizedDatePipe, TranslateModule, LsCardComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExhibitionCardComponent {
  @Input() exhibition: ExhibitionModel;

  protected readonly WebShopRoute = BaseRoute.WebShop;
}
